<template>
  <div class="loading-overlay">
    <div>
      <font-awesome-icon
        class="fa-pulse"
        size="3x"
        :icon="['fad', 'spinner']"
        style="--fa-secondary-color: #EAE3C5;--fa-secondary-opacity:1;--fa-primary-color: #ffcc00"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
}
</script>

<style scoped lang="scss">
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #8383837d;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
